import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./features/authSlice";
import { productApi } from "./services/productService";
import { ticketApi } from "./services/ticketService";
import { templateApi } from "./services/templateService";
import { loteApi } from "./services/loteService";
import { blockApi } from "./services/blockService";
import { forceApi } from "./services/forceService";
import { applicationApi } from "./services/applicationService";
import { supplierApi } from "./services/supplierService";
import { inventoryApi } from "./services/inventoryService";
import { reportApi } from "./services/reportService";
import { authApi } from "./services/authService";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [productApi.reducerPath]: productApi.reducer,
    [ticketApi.reducerPath]: ticketApi.reducer,
    [templateApi.reducerPath]: templateApi.reducer,
    [loteApi.reducerPath]: loteApi.reducer,
    [blockApi.reducerPath]: blockApi.reducer,
    [forceApi.reducerPath]: forceApi.reducer,
    [applicationApi.reducerPath]: applicationApi.reducer,
    [supplierApi.reducerPath]: supplierApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(productApi.middleware)
      .concat(ticketApi.middleware)
      .concat(templateApi.middleware)
      .concat(loteApi.middleware)
      .concat(blockApi.middleware)
      .concat(forceApi.middleware)
      .concat(applicationApi.middleware)
      .concat(supplierApi.middleware)
      .concat(inventoryApi.middleware)
      .concat(reportApi.middleware)
      .concat(authApi.middleware),
});

setupListeners(store.dispatch);
